import { HttpClient } from '@angular/common/http';
import { Injectable, Input } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseApi } from 'src/app/shared/_models/base-api';
import { environment } from 'src/environments/environment';
import { SessionUserInfoModel } from '../../_models/session-user-info.model';
import { ApiService } from '../api/api.service';
import { Router } from '@angular/router';
import { invitationType } from '../../../shared/_enums/enums';

@Injectable({ providedIn: 'root' })
export class UserDataService extends BaseApi {
  private user?: any;
  private userToken?: any;
  private companyID: any;
  private userRoleObs: BehaviorSubject<any> = new BehaviorSubject(null);
  private userObs: BehaviorSubject<any> = new BehaviorSubject(null);
  private userData: BehaviorSubject<any> = new BehaviorSubject(null);


  @Input()
  set tokenData(val) {
    this.userToken = val;
  }
  get tokenData() {
    return this.userToken;
  }

  constructor(
    private msalService: MsalService,
    private _apiService: ApiService,
    protected http: HttpClient,
    private router: Router
  ) {
    super();
    this.initUserObj();
  } // CONSTRUCTOR

  public getCompanyID() {
    this.initUserObj();
    const secretKey = sessionStorage.getItem('secretKey');
    if (secretKey !== null) {
      this.companyID = secretKey;
    }
    return this.companyID;
  } // FN

  public setCompanyId(companyObj?: any) {
    if (companyObj) {
      this.companyID = companyObj['id'];
      return of();
    } else {
      let userInfo: any;
      this.getuserObs().subscribe((result) => (userInfo = result));

      if (userInfo?.data?.companyId) {
        return this.http
          .get(
            environment['apiUrl'].concat(
              'Companies/GetCompanyById/',
              userInfo?.data.companyId
            )
          )
          .pipe(
            tap(
              (res: any) => {
                if (res?.data) {
                  this.companyID = res?.data.id;
                  sessionStorage.setItem('secretKey', this.companyID);
                }
              },
              (error) => {
              }
            )
          );
      } else {
        return this.http
          .get(
            environment['apiUrl'].concat(
              'Companies/GetCompanyByIdByEmail/',
              this.getUserEmail()
            )
          )
          .pipe(
            tap(
              (res: any) => {
                if (res.companyId) {
                  this.companyID = res.companyId;
                  sessionStorage.setItem('secretKey', res.companyId);
                }
              },
              (error) => {
              }
            )
          );
      }
    } // OUTER IF-ELSE
  } // FN

  private initUserObj() {
    this.user = this.msalService.instance.getAllAccounts();

    if (this.user.length > 0) {
      this.msalService.instance.setActiveAccount(this.user[0]);
    } // IF
  } // FN INIT-USER

  public getFullName() {
    const userData = this.user?.[0]?.idTokenClaims || null;

    if (userData?.given_name && userData?.family_name) {
      return `${userData.given_name} ${userData.family_name}`;
    } else {
      const email = userData?.extension_Email?.[0] || userData?.emails?.[0];
      if (email) {
        let emailSplit = email.split('@');
        return emailSplit[0]?.replace('.', ' ');
      }
    }
  }


  public getUserPhoneNo() {
    let userData = this.getUserData();
    if (userData == null) return '';
    else if (userData.extension_CountryCode && userData.extension_PhoneNumber)
      return userData.extension_CountryCode + userData.extension_PhoneNumber;
    else return '';
  }

  public getUserMembershipType() {
    let userData = this.getUserData();
    if (userData != null) return userData.extension_MembershipType;
    else return '';
  }
  public getUserMembershipPrice() {
    let userData = this.getUserData();
    if (userData != null) return userData.extension_MembershipPrice;
    else return '';
  }

  public getUserEmail() {
    this.user = this.msalService.instance.getAllAccounts();
    if (this.user && this.user.length > 0) {
      return this.user[0]?.username;
    }
    // IF
    return '';
  } // FN

  public getLoggedInUserDetails() {
    this.user = this.msalService.instance.getAllAccounts();
    if (this.user && this.user.length > 0) {
      let co_id = localStorage.getItem('companyId')
      let role_Id = localStorage.getItem('roleId')

      localStorage.setItem('userEmail', this.user[0]?.idTokenClaims?.email)
      let userEmail = this.user[0]?.username || this.user[0]?.idTokenClaims?.email
        || localStorage.getItem('userEmail');

      localStorage.setItem('isADLogin', JSON.stringify(this.user[0]?.idTokenClaims?.idp ? true : false));
      this.http
        .get(
          environment['apiUrl'].concat(
            'User/GetUserDetailsByEmail' + userEmail + ((co_id && co_id != 'null') ? '?co_id=' + co_id : '') + (role_Id ? '&role_id=' + role_Id : '')
          )
        )
        .subscribe(
          (res: any) => {

            if (res['result']?.length > 0) {
              localStorage.setItem('firstName', res.result[0]?.firsT_NAME);
              localStorage.setItem('lastName', res.result[0]?.last_Name);
              localStorage.setItem('companyId', res.result[0]?.co_Id);
              localStorage.setItem('userId', res.result[0]?.id);
              localStorage.setItem('isSuperAdmin', res.result[0]?.is_Super_Admin);
              localStorage.setItem('userName', res.result[0]?.user_Name)
              localStorage.setItem(
                'invitationTypeId',
                res.result[0]?.invitation_Type_Id //invitation_Type_Id
              );
              localStorage.setItem(
                'invitation_status',
                res.result[0]?.statuS_NAME
              );
              this.setUserDetails(res.result);

              if ((this.getInvitationType() == invitationType.Event ||
                this.getInvitationType() == invitationType.Company ||
                this.getInvitationType() == invitationType.Corporate)
                && (localStorage.getItem('invitation_status')) != 'Accepted') {
                this.router.navigate(['/legal-identity-verification']);
              }
            }
            else {
              this.router.navigate(['users/account-not-found']);
            }
          },
          (error) => {
          }
        );
    }
  }

  // company Switch
  public getUserSwitchDetails(userName: any, co_Id: any, role_id: any, roleName?: any) {
    this.http
      .get(
        environment['apiUrl'].concat(
          'User/GetUserDetailsByEmail' + userName + '?co_id=' + co_Id + '&role_id=' + role_id
        )
      )
      .subscribe(
        (res: any) => {
          if (res['result']?.length > 0) {
            localStorage.setItem('firstName', res.result[0]?.firsT_NAME);
            localStorage.setItem('lastName', res.result[0]?.last_Name);
            localStorage.setItem('companyId', res.result[0]?.co_Id);
            localStorage.setItem('userId', res.result[0]?.id);
            localStorage.setItem('isSuperAdmin', res.result[0]?.is_Super_Admin);
            localStorage.setItem('userName', res.result[0]?.user_Name)
            localStorage.setItem('roleId', role_id);
            localStorage.setItem(
              'invitationTypeId',
              res.result[0]?.invitation_Type_Id
            );
            localStorage.setItem(
              'invitation_status',
              res.result[0]?.statuS_NAME
            );
            this.setUserDetails(res.result);
            this.router.navigate(['dashboard']);
            setTimeout(function () {
              window.location.href = '/dashboard'
            }, 2000);
          }

          if ((this.getInvitationType() == invitationType.Event ||
            this.getInvitationType() == invitationType.Company) && (localStorage.getItem(
              'invitation_status')) != 'Accepted') {
            this.router.navigate(['/legal-identity-verification']);
          }
        },
        (error) => {
        }
      );

  }

  public getUserData() {
    this.initUserObj();

    const userData = this.user[0] ? this.user[0]?.idTokenClaims : null;
    return userData;
  } // FN GET-USER-DATA

  public getCompanyName() {
    const userData = this.getUserData();
    const companyKey = Object.keys(userData).find((key) => /CompanyName/.test(key)) ?? 'CBS';
    let companyName = userData[companyKey];
    // CONVERTED TO HYPHENATED STRING
    companyName = companyName.replace(/\s+/g, '-').toLowerCase();

    return companyName;
  } // FN GET-COMPANY-NAME

  public isSetupComplete(): boolean {
    const userData = this.getUserData();

    // TO DO: TEMPORARILY MADE COMPANY_ID TO DIRECT TO USERSETUP
    // USER SETUP NOT STARTED IF COMPANY ID CUSTOM ATTRIBUTE IS UNAVAILABLE
    if (Object.keys(userData).find((key) => /Company_ID/.test(key)))
      return true;
    else return false;
  } // FN IS-SETUP-COMPLETE

  itemName: any;
  setPopUpRecordName(name: string) {
    this.itemName = name;
  }

  getPopUpRecordName() {
    return this.itemName;
  }

  getuserRoleObs(): Observable<any> {
    return this.userRoleObs.asObservable();
  }

  setuserRoleObs(data: any) {
    this.userRoleObs.next(data);
  }
  getSignInUserRole() {
    return this.http
      .get(
        environment['apiUrl'].concat(
          'User/GetSigInUserRoleByEmail/',
          this.getUserEmail()
        )
      )
      .pipe(
        tap(
          (res: any) => { },
          (error) => {
          }
        )
      );
  }

  getMenuItemsByRole(roleId: string): Observable<any> {
    return this.http
      .get(environment['apiUrl'].concat('User/GetMenuItemsByRole/', roleId))
      .pipe(
        tap(
          (res: any) => { },
          (error) => {
          }
        )
      );
  }

  getuserObs(): Observable<any> {
    return this.userObs.asObservable();
  }

  setuserObs(data: any) {
    this.userObs.next(data);
  }

  setUserDetails(data: any) {
    this.userData.next(data);
  }

  getUserDetails(): Observable<any> {
    return this.userData.asObservable();
  }

  getMyInfo() {
    return this.http
      .get(environment['apiUrl'].concat('User/GetMyInfo/', this.getUserEmail()))
      .pipe(
        tap(
          (res: any) => { },
          (error) => {
          }
        )
      );
  }

  getCompanyById(companyId: string) {
    return this.http
      .get(environment['apiUrl'].concat('Companies/GetCompanyById/', companyId))
      .pipe(
        tap(
          (res: any) => {
            if (res?.data) {
              this.companyID = res?.data.Id;
              sessionStorage.setItem('secretKey', this.companyID);
            }
          },
          (error) => {
          }
        )
      );
  }

  activateInvoiceForFreeMembership(
    memberEmail: string,
    membershipType: string
  ) {
    return this.http
      .get(
        environment['apiUrl'].concat(
          'Payment/ActivateInvoiceForFreeMembership?MemberEmail=' +
          memberEmail +
          '&MembershipType=' +
          membershipType
        )
      )
      .pipe(
        tap(
          (result: any) => { },
          (error) => {
          }
        )
      );
  }

  getAspNetUserDetails() {
    return this.http
      .get(
        environment['apiUrl'].concat(
          'User/GetAspNetUserDetails/',
          this.getUserEmail()
        )
      )
      .pipe(
        tap(
          (res: any) => { },
          (error) => {
          }
        )
      );
  }

  getPendingInvitations(companyId: any) {
    return this.http
      .get(
        environment['apiUrl'].concat(
          'Invitation/GetPendingInvitations/',
          companyId
        )
      )
      .pipe(
        tap(
          (res: any) => { },
          (error) => {
          }
        )
      );
  }

  getMemberPersonalInfo(memberEmail?: string): SessionUserInfoModel {
    let userInfo = new SessionUserInfoModel();

    if (!memberEmail || memberEmail.length == 0) return userInfo;

    this.http
      .get(
        environment['apiUrl'].concat(
          `Profile/GetMemberPersonalInfo?MemberEmail=${memberEmail}`
        )
      )
      .subscribe((result: any) => {
        if (result.contactID == '00000000-0000-0000-0000-000000000000') {
          userInfo.personalEmail = memberEmail;
        } else {
          userInfo.firstName = result.firstName;
          userInfo.middleName = result.middleName;
          userInfo.lastName = result.lastName;
          userInfo.personalEmail = result.personalEmail;
          userInfo.personalPhone = result.personalPhone;
          userInfo.membershipType = result.membershipType;
          userInfo.membershipName = result.membershipName;
          userInfo.membershipId = result.nblid;
          userInfo.companyId = result.companyId;
          userInfo.companyName = result.companyName;
        }

        return userInfo;
      });

    return userInfo;
  }

  UpdateInvitation(obj: any): Observable<any> {
    return this.http.post(
      this.getApiUrl(`Invitation/UpdateUserInvitation`),
      obj
    );
  }

  deleteUser(emailId: string) {
    return this._apiService.delete('User/DeleteUser/' + emailId);
  } // FN

  lockUser(obj: any): Observable<any> {
    return this.http.post(this.getApiUrl(`Contacts/DisableUser`), obj);
  }

  deleteUserInvitation(Id: string) {
    return this._apiService.delete('Invitation/DeleteUserInvitation/' + Id);
  } // FN

  AddLogonActivity(requestObj: any): Observable<any> {
    return this.http.post(this.getApiUrl(`User/AddLogonActivity`), requestObj);
  }

  getInvitationType(): any {
    return localStorage.getItem('invitationTypeId');
  }
} // EXPORT
